import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-canvas',
    templateUrl: './canvas.component.html',
    styleUrls: ['./canvas.component.scss'],
    standalone: false
})
export class CanvasComponent implements OnInit {
  ocultarPie = false;

  constructor(private router: Router) {
    this.ocultarPie = this.esRutaValidacionPublica();
    // on route change to '/login', set the variable showHead to false
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event['url'] == '/') {
          localStorage.setItem('showHeader', 'false');
        } else {
          const token = localStorage.getItem('authorization');
          if (token) {
            localStorage.setItem('showHeader', 'true');
          }
        }
      }
    });
    router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.ocultarPie = this.esRutaValidacionPublica();
    });
  }
  readLocalStorageValue() {
    return localStorage.getItem('showHeader');
  }
  ngOnInit() {
    this.ocultarPie = this.esRutaValidacionPublica();
  }

  private esRutaValidacionPublica(): boolean {
    const rutaActual = window.location.pathname;
    const uidDocumento = /^\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}\/?$/;
    return rutaActual.startsWith('/certificados/verificar')
      || uidDocumento.test(rutaActual)
      || this.router.url.startsWith('/certificados/verificar');
  }

}
